module.exports = "https://assets.calmac.co.uk/scripts/apps/overlays/1.9/img/tickBlack.svg";